import { Injectable, OnDestroy } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ProdutividadeFilter, ProdutividadeViewProps } from '../adapters';


@Injectable({
  providedIn: 'root'
})
/**
 * Service para as views dos KPIs de produtividade
 */
export class ProdutividadeViewService implements OnDestroy {
    /** Props da view */
    private props: ProdutividadeViewProps = {
        filter: null
    };
    private propsSubject = new BehaviorSubject<ProdutividadeViewProps>(this.props);
    props$ = this.propsSubject.asObservable();

    // Load
    private loadSubject = new Subject<ProdutividadeFilter>();
    load$ = this.loadSubject.asObservable();
    /** BehaviorSubject que indica se está carregando a view */
    private _isLoading = new BehaviorSubject<boolean>(false);

    /** Executa o evento para carregar a view */
    execLoad(filter: ProdutividadeFilter) {
        this.setFilter(filter);
        this.loadSubject.next(filter);
    }

    /** Flag que indica se está carregando a view */
    get isLoading$(): Observable<boolean> {
        return this._isLoading.asObservable();
    }

    /** Seta se está carregando a view */
    setIsLoading(isLoading: boolean) {
        this._isLoading.next(isLoading);
    }

    /** Retorna o filtro da view */
    getFilter(): ProdutividadeFilter {
        return this.props?.filter ?? null;
    }

    /** Seta o filtro da view */
    setFilter(filter: ProdutividadeFilter) {
        this.props.filter = filter;
        this.propsSubject.next(this.props);
    }

    ngOnDestroy(): void {
        this.loadSubject.unsubscribe();
        this.propsSubject.unsubscribe();
    }
}
